import { GridFilterItem } from "../../Unknown/DataGrid";

const checkIsFilterEmpty = (filterItem: GridFilterItem): boolean => {
  return !filterItem.value || !filterItem.value.length;
};

export default checkIsFilterEmpty;
